import {
  TaskCheckmarkFilledNew,
  StartFlag,
  PersonInfo,
} from '@teo/components/icons';
import { ProgressBar } from '@teo/components';
import { useEffect, useState, useContext } from 'react';
import { sortDataLP } from '@/components/LearningPath/util';
import { axios } from '@/axios';
import { config } from '@/config';
import { AuthContext } from '@/components/Contexts/AuthContext';

export const LpProgress = ({ allNodes, lpGroup, activeItem, follow }) => {
  const [allMilestones, setAllMilestones] = useState(null);
  const { auth } = useContext(AuthContext);
  const getAllBeforeById = (array, id) => {
    const index = array.findIndex((el) => el.objectId === id || el.id === id);
    if (index !== -1) {
      return array.slice(0, index);
    }
    return [];
  };

  const getBeforeById = (array, id) => {
    const index = array.findIndex((el) => el.objectId === id || el.id === id);

    if (index === -1) return [];

    let prevIndex = -1;
    for (let i = index - 1; i >= 0; i--) {
      if (array[i].subType === 'milestone') {
        prevIndex = i;
        break;
      }
    }

    return array.slice(prevIndex + 1, index);
  };

  const lpGroupProgress = async () => {
    const lpContent = allNodes?.filter(
      (nds) => nds?.learningpathId === lpGroup?.learningpathId
    );

    if (lpContent?.length > 0) {
      const sortData = sortDataLP(lpContent);
      const allBeforeMl = getAllBeforeById(sortData, activeItem?.id).filter(
        (nds) => nds?.subType === 'milestone'
      );

      const allLpMilestones = sortData?.filter(
        (nds) => nds?.subType === 'milestone'
      );
      const newNodedetails = [];
      for (const mls of allLpMilestones) {
        const exists =
          lpGroup?.order === 'fixed'
            ? allBeforeMl.some((el) => el.objectId === mls?.objectId)
            : true;
        let milestonesDetail = null;
        const beforeContent = getBeforeById(sortData, mls?.id);
        const beforeDoneContent = beforeContent?.filter(
          (el) => el?.progress === 1
        );
        let beforeProg = 0;

        beforeContent?.map((el) => {
          beforeProg = beforeProg + (el.skippedByCompetences ? 1 : el.progress);
        });

        try {
          milestonesDetail = await axios.get(
            `${config.backend}/training/${mls?.objectId}`
          );
          newNodedetails.push({
            ...milestonesDetail?.data,
            isCompleted: mls?.status === 'completed' && exists,
            mlsProgress: beforeProg / beforeContent?.length,
          });
        } catch (error) {
          console.error(error);
        }
      }
      setAllMilestones(newNodedetails);
    }
  };

  useEffect(() => {
    if (allNodes) {
      lpGroupProgress();
    }
  }, [allNodes]);

  return (
    <div className="my-4 flex w-full flex-row items-center gap-2 ">
      {allMilestones?.length > 1 ? (
        <>
          {allMilestones?.map((el) => {
            return (
              <div key={el.id} className="flex w-full items-center gap-2">
                <ProgressBar
                  max={100}
                  value={
                    el?.isCompleted ? 100 : Math.round(el.mlsProgress * 100)
                  }
                  className={` h-1 overflow-hidden rounded-lg ${
                    el?.isCompleted ||
                    (follow.lpProgress === 1 && 'progress-bar__all')
                  }`}
                />
                {el?.typeOfTraining === 'certificate' ? (
                  <TaskCheckmarkFilledNew
                    className={`h-5 w-5 ${
                      el?.isCompleted ? 'text-black' : 'text-grey-04'
                    }`}
                  />
                ) : el?.typeOfTraining === 'endpoint' ? (
                  <StartFlag
                    className={`h-5 w-5 ${
                      el?.isCompleted ? 'text-black' : 'text-grey-04'
                    }`}
                  />
                ) : (
                  <PersonInfo
                    className={`h-5 w-5 ${
                      el?.isCompleted ? 'text-black' : 'text-grey-04'
                    }`}
                  />
                )}
              </div>
            );
          })}
          <span className="pl-3 text-xs text-grey-06">
            {Math.round(follow.lpProgress * 100)}%
          </span>
        </>
      ) : (
        <>
          <div className="flex w-full items-center gap-2">
            <ProgressBar
              max={100}
              value={
                follow.lpProgress ? Math.round(follow.lpProgress * 100) : 0
              }
              className={` h-1 overflow-hidden rounded-lg ${
                follow.lpProgress === 1 && 'progress-bar__all'
              }`}
            />
          </div>
          <span className="pl-3 text-xs text-grey-06">
            {Math.round(follow.lpProgress * 100)}%
          </span>
        </>
      )}
    </div>
  );
};
